export default "__VITE_PUBLIC_ASSET__4b4e2e17__"